document.addEventListener("DOMContentLoaded",function() {
	const rejectButton = document.querySelector(".button--reject");
	const acceptButton = document.querySelector(".button--accept");

	rejectButton && rejectButton.addEventListener("click", function () {
		// Cookies rejected - hide banner and specify rejection
		document.getElementsByClassName("cookie-consent-banner")[0].classList.add("cookie-consent-banner--close");
		document.cookie = "consent=false; expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/";
	})

	acceptButton && acceptButton.addEventListener("click", function () {
		// Cookies accepted - hide banner and specify acception
		document.getElementsByClassName("cookie-consent-banner")[0].classList.add("cookie-consent-banner--close");
		document.cookie = "consent=true; expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/";
	})

	if(document.cookie['consent']) {
		// Storage already set, hide banner
		document.getElementsByClassName("cookie-consent-banner")[0].classList.add("cookie-consent-banner--close");
	}
});